export default {"src":"/_next/static/media/savings.a4735ea3.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};